import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal = ({ isOpen, onClose }: SuccessModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-center text-2xl text-green-600">
            Congratulations! 🎉
          </DialogTitle>
        </DialogHeader>
        <div className="text-center py-4">
          <p className="text-gray-700 mb-6">
            You now have access to all JAMBACE years and questions!
          </p>
          <button
            onClick={onClose}
            className="bg-primary text-white px-8 py-2 rounded-md hover:bg-primary/90 transition-colors"
          >
            Okay
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal; 